module.exports = __webpack_public_path__ + "img/color8_on.28e7c55c.png";